const EMPTY_SUMMARY = {
    needsAttention: [],
    recentActivity: [],
    paymentMethodsCount: 0
};
export function useClientSummary(_clientId) {
    return {
        summary: EMPTY_SUMMARY,
        isLoading: false
    };
}
